import React, { useContext } from "react";
import { PatientContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Row, Col } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import styled from "styled-components";

import { addTrackedFactorsUnpaused, removePausedFactor } from "../../api/TBIRequests";

const Container = styled.div`
  margin: 10px;
  h6 { text-align: center; }
  ul { font-weight: normal; font-size: 15px; margin: 10px; }
`;

const UlPausedList = ({
  symptoms, title, setPauseList, pausedFactorObj, setPausedFactorObj,
  setTopSymptoms, topSymptomsList, user,
}) => {
  const { patient } = useContext(PatientContext);
  const { t } = useTranslation();

  const tSymptom = (category, factor) => {
    const key = `symptom.${category}.${factor.toLowerCase()
      .replace(/ /g,"_").replace(/\//g,"_").replace(/,/g,"")
      .replace(/:/g,"").replace(/'/g,"").replace(/[()]/g,"").replace(/-/g,"_")
      .substring(0, 60)}`;
    const translated = t(key);
    return translated !== key ? translated : factor;
  };

  const removePauseF = (factor) => {
    let newParsedFactors = [...symptoms];
    if (newParsedFactors && newParsedFactors.includes(factor)) {
      const index = newParsedFactors.indexOf(factor);
      if (index > -1) {
        newParsedFactors.splice(index, 1);
        setPauseList(newParsedFactors);
      }
    }
    removePausedFactor({
      patientId: patient.patientId,
      data: [factor],
      therapistId: user.userType === "Therapist" ? user.userId : null,
    }).catch(() => console.log("removePausedFactor error"));
  };

  const messages = {
    cognitive: `${t("addsymptoms.category.cognitive")}: `,
    sleep: `${t("addsymptoms.category.sleep")}: `,
    physical: `${t("addsymptoms.category.physical")}: `,
    emotional: `${t("addsymptoms.category.emotional")}: `,
    speech: `${t("addsymptoms.category.speech")}: `,
    vision: `${t("addsymptoms.category.vision")}: `,
  };

  const tabs = {
    cognitive: t("addsymptoms.category.cognitive"),
    sleep: t("addsymptoms.category.sleep"),
    physical: t("addsymptoms.category.physical"),
    emotional: t("addsymptoms.category.emotional"),
    speech: t("addsymptoms.category.speech"),
    vision: t("addsymptoms.category.vision"),
  };

  const addTracking = (factor) => {
    const objWithFactor = pausedFactorObj?.find((symptom) => symptom.factor === factor);
    const filteredFactorsList = pausedFactorObj?.filter((symptom) => symptom.factor !== factor);
    setPausedFactorObj(filteredFactorsList);
    let newTopSymptoms = [...topSymptomsList];
    newTopSymptoms.push(objWithFactor);
    setTopSymptoms(newTopSymptoms);
    addTrackedFactorsUnpaused({
      patientId: patient.patientId,
      therapistId: user.userType === "Therapist" ? user.userId : null,
      data: [[factor]],
    }).catch(() => console.log("addTrackedFactorsUnpaused error"));
  };

  const uniqueSubcategories = new Set();
  pausedFactorObj.forEach((symptom) => uniqueSubcategories.add(symptom.subcategory));
  const uniqueSubcategoryArray = Array.from(uniqueSubcategories);

  const colors = {
    cognitive: "#edebf3", sleep: "#ffdadb", physical: "#ffdcaf",
    emotional: "#fff3c4", speech: "#cef3c4", vision: "#c1fdf7",
    wellness: "#dab7ec", travel: "#ffdadb", "screen time": "#ffdcaf",
    environmental: "#fff3c4", Dietary: "#cef3c4", situational: "#c1fdf7",
    Alternative: "#dab7ec", Applied: "#ffdadb", Chiropractic: "#ffdcaf",
    Vision: "#fff3c4", "Mental Health": "#c1fdf7", Other: "#f4f3ee",
  };

  return (
    <Container>
      <h6>{title}</h6>
      <Tab.Container id="left-tabs-example" defaultActiveKey="cognitive">
        <Row style={{ marginTop: "0.5rem", fontWeight: "normal", fontSize: "15px" }}>
          <Col sm={3} style={{ paddingRight: "0px" }}>
            <Nav fill justify variant="tabs" className="flex-column">
              {uniqueSubcategoryArray.map((subcategory, i) => (
                <Nav.Item key={i}>
                  <Nav.Link
                    className="navLink"
                    eventKey={subcategory}
                    style={{ background: `${colors[subcategory]}`, border: "1px solid #106995" }}
                  >
                    {" "}{tabs[subcategory]}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
          <Col sm={7} style={{ marginLeft: "1rem", paddingRight: "0px" }}>
            <Tab.Content>
              {uniqueSubcategoryArray.map((subcategory, i) => (
                <Tab.Pane eventKey={subcategory} key={i}>
                  <h6 className="d-inline">{messages[subcategory]}</h6>
                  <ul className="list-disc pl-1">
                    {pausedFactorObj
                      .filter((symptom) => symptom.subcategory === subcategory)
                      .map((filteredSymptom, j) => (
                        <li key={j} className="mb-2">
                          {tSymptom(subcategory, filteredSymptom.factor)}{" "}
                          <button
                            onClick={() => {
                              removePauseF(filteredSymptom.factor);
                              addTracking(filteredSymptom.factor);
                            }}
                            className="px-2 py-1 rounded bg-green-500 text-white hover:bg-green-900 transition"
                          >
                            {t("ulpausedlist.unpause")}
                          </button>
                        </li>
                      ))}
                  </ul>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default UlPausedList;